import AppContext from "PFApp/app_context";
import EchartsWrapper from "PFCore/helpers/echarts_wrapper";
import useInsightsApi from "PFCore/helpers/use_insights_api";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import BarPreview from "../../previews/bar_preview";
import { rolesOverTimeChartConfig } from "./configs/roles_over_time_chart_config";
import css from "./roles_hist_chart.module.scss";

const RolesOverTimeChart = () => {
  const {
    store: {
      pages: {
        insights: { selectedFilters }
      }
    }
  } = useContext(AppContext);
  const { t } = useTranslation("insights");
  const { formatDate } = useDateFormatter();
  const [rolesOverTime, setRolesOverTime] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const { insightsApi, insightsApiError } = useInsightsApi();

  useEffect(() => {
    setLoading(true);
    insightsApi("/roles_over_time", {
      ...selectedFilters
    }).then((res) => {
      if (res.roles_over_time) {
        setRolesOverTime(res.roles_over_time.lines);
      }
      setLoading(false);
    });
  }, [selectedFilters]);

  if (insightsApiError) {
    return <BarPreview content={t("noData")} />;
  }

  const displayContent = Boolean(rolesOverTime);

  if (loading && !displayContent) {
    return <BarPreview animated content={t("loading")} />;
  }

  return (
    <>
      <div className={css.wrapper}>
        <div className={css.chart}>
          {rolesOverTime?.length > 0 && !insightsApiError ? (
            <EchartsWrapper
              height={500}
              options={rolesOverTimeChartConfig(
                t("staffingOverTime"),
                [t("unfilledPassDue"), t("rolesCreatedPerDay"), t("rolesFilledPerDay")],
                rolesOverTime.map((item) => formatDate(item.date)),
                [
                  rolesOverTime.map((item) => item.unfilled_passed_due),
                  rolesOverTime.map((item) => item.roles_created_per_day),
                  rolesOverTime.map((item) => item.roles_filled_per_day)
                ]
              )}
            />
          ) : (
            <BarPreview content={t("noData")} />
          )}
        </div>
      </div>
    </>
  );
};

export default RolesOverTimeChart;
